/**
 * Format a date to a human-readable format: 'MM/DD/YYYY at HH:MM AM/PM TZ'
 * @param {string} date
 * @param {string} timezone
 */
export const formatToReadableDate = (date, timezone) => {
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }

    let readableDate = date
        .toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: timezone,
            timeZoneName: 'short',
        })
        .replace(/\//g, '-')
        .replace(',', '');

    // Insert "at" between the date and time
    const [datePart, timePart, periodPart, tzPart] = readableDate.split(' ');
    readableDate = `${datePart} at ${timePart} ${periodPart} ${tzPart}`;
    return readableDate;
};

export const parseCallbackTime = callback_at => {
    const callbackDate = new Date(callback_at.replace(' ', 'T')); // Convert to ISO format
    return callbackDate
        .toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
        })
        .split(':');
};
